import { useState, type FormEvent } from 'react';
import { discussions } from '@/mocks/homeData';

export default function Discussion() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [board, setBoard] = useState(discussions);
  const [notice, setNotice] = useState('');

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePost = (e: FormEvent) => {
    e.preventDefault();
    const content = draft.trim();
    if (!content) {
      setNotice('先写点什么，再发出来吧。');
      return;
    }
    setBoard((prev) => [
      {
        id: `local-${Date.now()}`,
        author: '我',
        initials: '我',
        time: '刚刚',
        movie: '影迷讨论区',
        content,
        likes: 0,
        replies: 0,
      },
      ...prev,
    ]);
    setDraft('');
    setNotice('已发布到讨论区（本页仅作展示，不会真正提交）。');
  };

  return (
    <section id="talk" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-800">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              影迷热议
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              看完想找人聊两句？这里最热闹
            </h2>
            <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-600">
              每部片单下面都有人接着聊，从伏笔到结局，想说两句就留下你的看法。
            </p>

            <form onSubmit={handlePost} className="mt-6 rounded-xl border border-background-200 bg-background-50 p-4">
              <textarea
                value={draft}
                maxLength={200}
                onChange={(e) => setDraft(e.target.value)}
                rows={4}
                placeholder="说说你最近看完的片子，或者给同好推荐一部冷门佳作"
                className="w-full resize-none bg-transparent text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              ></textarea>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-xs text-foreground-400">{draft.length}/200</span>
                <button
                  type="submit"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-accent-600 cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-send-plane-line text-base"></i>
                  </span>
                  发布看法
                </button>
              </div>
              {notice ? <p className="mt-2.5 text-xs text-secondary-600">{notice}</p> : null}
            </form>
          </div>

          <div className="flex flex-col gap-4">
            {board.map((item) => (
              <article key={item.id} className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-semibold text-primary-800">
                    {item.initials}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-foreground-900">{item.author}</p>
                    <p className="mt-0.5 text-xs text-foreground-400">{item.time}</p>
                  </div>
                  <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-movie-2-line text-sm"></i>
                    </span>
                    {item.movie}
                  </span>
                </div>
                <p className="mt-3.5 text-sm leading-relaxed text-foreground-700">{item.content}</p>
                <div className="mt-4 flex items-center gap-5">
                  <button
                    type="button"
                    onClick={() => toggleLike(item.id)}
                    className={`inline-flex items-center gap-1.5 text-sm transition cursor-pointer ${
                      liked[item.id] ? 'text-accent-600' : 'text-foreground-500 hover:text-accent-600'
                    }`}
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={liked[item.id] ? 'ri-heart-fill text-base' : 'ri-heart-line text-base'}></i>
                    </span>
                    {item.likes + (liked[item.id] ? 1 : 0)}
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-500 transition hover:text-primary-600 cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-chat-3-line text-base"></i>
                    </span>
                    {item.replies} 条回复
                  </button>
                  <button
                    type="button"
                    className="ml-auto inline-flex items-center gap-1.5 text-sm text-foreground-500 transition hover:text-primary-600 cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-share-forward-line text-base"></i>
                    </span>
                    转发
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}